import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComplianceImportComponent } from '../compliance-import/compliance-import.component';
import { DatabaseService } from '../../../services/database.service';
import { environment } from '../../../services/global-environment';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EmailService } from '../../../services/email.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
// 匯入新建立的模型和工廠函式
import { law_unfit_list, createRegulationUnfitItem } from '../../../models/regulation-unfit-item.model';
import { law_unfit_list_extend, createExtendedRegulationUnfitItem } from '../../../models/regulation-unfit-item-extend.model';

// 用戶介面
interface User {
  id?: string;
  username: string;
  password: string;
  email: string;
  fullName: string;
  department: string;
  position: string;
  enabled: boolean;
  createdAt?: Date;
  lastLogin?: Date;
  permissions: any[];
}

// export interface TrackingItem {
//   id: number;
//   check_result_id?: string; // 用於關聯檢查結果
//   title: string;
//   description: string;
//   status: 'pending' | 'in-progress' | 'completed';
//   priority: 'high' | 'medium' | 'low';
//   assignee: string;
//   dueDate: string;
//   createdAt: string;
//   updatedAt: string;
//   relatedRegulation?: string;
//   law_name?: string;
//   article_no?: string;
//   article_content?: string;
//   currentSituation?: string;
//   riskOpportunity?: string[];
//   eliminate?: string[];
//   substitute?: string[];
//   solution?: string[];
//   improvementContent?: string;
//   estimatedCloseDate?: string;
//   remark?: string;
// }

@Component({
  selector: 'app-tracking-item',
  standalone: true,
  imports: [CommonModule, FormsModule, ComplianceImportComponent],
  templateUrl: './tracking-item.component.html',
  styleUrl: './tracking-item.component.scss',
})
export class TrackingItemComponent implements OnInit {
  // 將類型改為擴展類型
  trackingItems: law_unfit_list_extend[] = [];
  showItemModal = false;
  isEditMode = false;
  currentItem: any = {
    status: 'pending',
    priority: 'medium',
    createdAt: new Date().toISOString().split('T')[0],
    riskOpportunity: [],
    solution: [],
    attachments: [],
  };
  riskOpportunityOptions = ['風險', '機會'];
  solutionOptions = ['消除', '取代', '工程控制', '標誌警告/管理控制', '防護具'];

  // 狀態選項定義 (key-value 形式)
  statusOptions = [
    { key: '待處理', value: 'pending' },
    { key: '處理中', value: 'in_progress' },
    { key: '待審核', value: 'review' },
    { key: '審核完成', value: 'approved' }
  ];

  // 篩選狀態選項
  filterStatusOptions = [
    { key: '全部', value: 'all' },
    ...this.statusOptions
  ];

  filterStatus: string = 'all';
  filterPriority: string = 'all';
  sortBy: string = 'dueDate';
editingItemId: string | number | null = null;

  availableComplianceItems: number = 0; // 由API取得
  unfitItems: any[] = []; // 存放API回傳的items
  selectedUnfitItemIds: Set<string> = new Set(); // 勾選的ID

  // --- Added for compliance import modal ---
  showComplianceImportModal: boolean = false;
  companyid: string = ""; // 公司ID，根據實際情況設定
  // -----------------------------------------

  users: User[] = [];

  private apiUrl = environment.apiUrl;

  // 新增匯出狀態
  isExporting: boolean = false;

  constructor(
    private databaseService: DatabaseService,
    private emailService: EmailService,
    private router: Router,
    private http: HttpClient // 新增HttpClient
  ) {}

  ngOnInit(): void {


    this.companyid = environment.companyid

    this.loadUnfitItems(); // 改為載入實際的不合規項目
    this.loadUsers();
    this.fetchUnfitItems(); // 取得不符合項目
  }

  // 載入用戶資料
  loadUsers(): void {
    const companyId = environment.companyid;

    this.databaseService
      .getUsersByCompanyId(companyId)
      .pipe(
        map((response: any) => {
          console.log('Response from getUsersByCompanyId:', response);

          if (!response?.success || !Array.isArray(response.data)) {
            return [];
          }
          return response.data.map((item: any) => ({
            username: item.username,
            email: item.email || '',
          }));
        }),
        catchError((error) => {
          console.error('Error loading users:', error);
          return of([]);
        })
      )
      .subscribe((users: User[]) => {
        this.users = users;

        console.log('Loaded users:', this.users);
      });
  }

  fetchUnfitItems(): void {
    const companyid = environment.companyid;
    const url = `${this.apiUrl}/api/law_check_list/find_unfit_items`;
    this.http.post<any>(url, { companyid }).subscribe({
      next: (res) => {
        if (res?.success) {
          console.log('不符合項目:', res.items);

          this.unfitItems = res.items || [];
          this.availableComplianceItems = res.count || 0;
        } else {
          this.unfitItems = [];
          this.availableComplianceItems = 0;
        }
      },
      error: () => {
        this.unfitItems = [];
        this.availableComplianceItems = 0;
      },
    });
  }

  // 取代原有的 loadSampleData 方法，改為從 API 獲取實際數據
  loadUnfitItems(): void {
    const companyid = environment.companyid;
    const url = `${this.apiUrl}/api/regulation/unfit/list?companyid=${companyid}`;

    this.http
      .get<any>(url)
      .pipe(
        map((response) => {
          if (response?.success && Array.isArray(response.data)) {
            return response.data.map((item: any) =>
              this.mapUnfitItemToTrackingItem(item)
            );
          }
          return [];
        }),
        catchError((error) => {
          console.error('獲取不合規項目列表失敗:', error);
          return of([]); // 發生錯誤時返回空數組
        })
      )
      .subscribe((items) => {
        this.trackingItems = items;
        console.log('已載入不合規項目清單:', this.trackingItems);
      });
  }

  // 將 API 回傳的不合規項目對應到 TrackingItem 格式
  private mapUnfitItemToTrackingItem(item: any): law_unfit_list_extend {
    // 先創建基本的 law_unfit_list 物件
    const baseItem: law_unfit_list = {
      id: item.id, // 如果 API 沒有提供 ID，則生成一個
      companyid: item.companyid, // 使用項目的公司 ID 或當前環境的公司 ID
      topic: item.topic || '',
      title: item.title || '',
      missionid: item.missionid || '',
      check_result_id: item.check_result_id || '',

      law_id: item.law_id || '',
      law_name: item.law_name || '',
      article_id: item.article_id || '',
      article_no: item.article_no || '',
      article_content: item.article_content || '',
      current_status: item.current_status || '',

      assignee: item.assignee || '',
      email: item.email || '',
      dueDate: item.dueDate || '',

      riskOpportunity: item.riskOpportunity || [],
      solution: item.solution || [],
      improvementContent: item.improvementContent || '',
      attachments: item.attachments || [],
      status: item.status || '',
      priority: item.priority || '',
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    };

    // 使用工廠函數創建擴展項目
    return createExtendedRegulationUnfitItem(baseItem);
  }

  openAddItemModal(): void {
    this.isEditMode = false;
    this.currentItem = {
      status: 'pending',
      priority: 'medium',
      createdAt: new Date().toISOString().split('T')[0],
      riskOpportunity: [],
      solution: [],
      attachments: [],
    };
    this.showItemModal = true;
    document.body.style.overflow = 'hidden';
  }

  openEditItemModal(item: law_unfit_list): void {
    this.isEditMode = true;
    this.currentItem = JSON.parse(JSON.stringify(item));
    if (!this.currentItem.riskOpportunity) {
      this.currentItem.riskOpportunity = [];
    }
    if (!this.currentItem.solution) {
      this.currentItem.solution = [];
    }
    this.showItemModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeItemModal() {
    this.showItemModal = false;
    document.body.style.overflow = 'auto';
  }

  onModalBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeItemModal();
    }
  }

  // 發送通知確認對話框
  showEmailConfirm = false;
  itemToSave: any = null;

  // 儲存項目
  saveItem() {
    // 基本驗證
    if (!this.currentItem.law_name) {
      alert('請填寫法規名稱');
      return;
    }

    // 儲存前先設置項目
    this.itemToSave = { ...this.currentItem };

    // 檢查是否需要顯示發送通知確認
    if (this.currentItem.email) {
      this.showEmailConfirm = true;
    } else {
      // 若沒有設定信箱，直接儲存不發通知
      this.saveItemOnly();
    }
  }

  // 取消發送通知
  cancelEmailConfirm(event?: Event) {
    if (event) {
      // 點擊的是對話框背景時
      const target = event.target as HTMLElement;
      if (target.classList.contains('confirm-email-overlay')) {
        this.showEmailConfirm = false;
        // 依然儲存項目，但不發送通知
        this.saveItemOnly();
      }
    } else {
      // 點擊「否，不發送」按鈕
      this.showEmailConfirm = false;
      this.saveItemOnly();
    }
  }

  // 確認發送通知
  confirmSendEmail() {
    this.showEmailConfirm = false;
    this.saveItemOnly(true);
  }

  // 儲存項目，可選擇是否發送通知
  private saveItemOnly(sendNotification: boolean = false) {
    if (!this.itemToSave) return;

    if (this.isEditMode) {
      // 更新既有項目
      this.updateTrackingItem(this.itemToSave, sendNotification);
    } else {
      // 創建新項目
      this.createTrackingItem(this.itemToSave, sendNotification);
    }

    // 關閉模態
    this.closeItemModal();
    this.itemToSave = null;
  }

  // 更新追蹤項目
  private updateTrackingItem(item: any, sendNotification: boolean = false) {
    // 編輯模式：呼叫 API 更新資料庫
    const companyid = environment.companyid ;
    const apiUrl = `${this.apiUrl}/api/regulation/unfit/update/${item.id}`;

    // 準備要送出的資料
    const updateData = {
      ...item,
      companyid,
      // 預留給 API 自動添加更新時間
    };

    // 可選：顯示 loading 狀態
    // this.isLoading = true;

    this.http.put<any>(apiUrl, updateData).subscribe({
      next: (res) => {
        if (res && res.success && res.data) {
          // 更新成功，更新本地資料
          const index = this.trackingItems.findIndex(
            (trackingItem) => trackingItem.id === item.id
          );
          if (index !== -1) {
            // 使用 API 返回的最新資料
            this.trackingItems[index] = this.mapUnfitItemToTrackingItem(
              res.data
            );


            var email = this.trackingItems[index].email;

            // console.log('更新後的項目:', this.trackingItems[index]);
            // console.log('發送通知:', sendNotification);
            // console.log('指派負責人:', this.trackingItems[index].assignee);
            // console.log('email:', this.trackingItems[index].email );

            // 如果有指派負責人，發送通知郵件
            if (email && sendNotification) {
              this.sendNotificationEmail(this.trackingItems[index]);
            }
          }
          this.closeItemModal();
        } else {
          alert(res?.message || '更新失敗');
        }
        // this.isLoading = false;
      },
      error: (err) => {
        if (err.status === 404) {
          alert('找不到要更新的項目');
        } else {
          alert('更新失敗，請稍後再試');
        }
        console.error('API 更新錯誤:', err);
        // this.isLoading = false;
      },
    });
  }

  // 創建追蹤項目
  private createTrackingItem(item: any, sendNotification: boolean = false) {
    // 新增模式：呼叫 API 寫入資料庫
    const companyid = environment.companyid;
    const apiUrl = `${this.apiUrl}/api/regulation/unfit/add`;

    // 準備要送出的資料
    const itemData = {
      ...item,
      companyid,
      // id, createdAt, updatedAt 由後端自動產生或補齊
    };

    // 可選：顯示 loading 狀態
    // this.isLoading = true;

    this.http.post<any>(apiUrl, itemData).subscribe({
      next: (res) => {
        if (res && res.success && res.data) {
          // 將新資料加到 trackingItems
          const newItem = this.mapUnfitItemToTrackingItem(res.data);
          this.trackingItems.push(newItem);
          // 寄信通知
          this.sendNotificationEmail(newItem);
          this.closeItemModal();
        } else {
          alert(res?.message || '新增失敗');
        }
        // this.isLoading = false;
      },
      error: (err) => {
        alert('新增失敗，請稍後再試');
        // this.isLoading = false;
      },
    });
  }

  /**
   * Send notification email to the assignee
   */
  private sendNotificationEmail(item: any) {

    // Format the date in a readable format
    const formattedDate = new Date(item.dueDate).toLocaleDateString('zh-TW');

    // Generate task URL
    const baseUrl = window.location.origin;
    const taskUrl = `${baseUrl}/regulations/tracking-items/${item.id}`;


    this.emailService
      .sendRegulationTrackingNotification(
        item.email,
        item.assignee || "使用者",
        item,
        formattedDate,
        taskUrl
      )
      .subscribe({
        next: () => {
          console.log('Notification email sent successfully');
        },
        error: (error) => {
          console.error('Error sending notification email:', error);
        },
      });
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      if (!this.currentItem.attachments) {
        this.currentItem.attachments = [];
      }
      this.currentItem.attachments = this.currentItem.attachments.concat(files);
      input.value = '';
    }
  }

  removeAttachment(index: number): void {
    if (
      this.currentItem.attachments &&
      this.currentItem.attachments.length > index
    ) {
      this.currentItem.attachments.splice(index, 1);
    }
  }

  getRemainingDays(dueDate: string): number {
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due.getTime() - today.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'pending':
        return 'status-pending';
      case 'in-progress':
        return 'status-in-progress';
      case 'completed':
        return 'status-completed';
      default:
        return '';
    }
  }

  getPriorityClass(priority: string): string {
    switch (priority) {
      case 'high':
        return 'priority-high';
      case 'medium':
        return 'priority-medium';
      case 'low':
        return 'priority-low';
      default:
        return '';
    }
  }

  getDaysRemainingClass(days: number): string {
    if (days < 0) return 'days-overdue';
    if (days <= 7) return 'days-urgent';
    if (days <= 14) return 'days-warning';
    return 'days-normal';
  }

  get filteredItems(): law_unfit_list_extend[] {
    let result = [...this.trackingItems];

    if (this.filterStatus !== 'all') {
      result = result.filter((item) => item.status === this.filterStatus);
    }

    if (this.filterPriority !== 'all') {
      result = result.filter((item) => item.priority === this.filterPriority);
    }

   result.sort((a, b) => {
  if (this.sortBy === 'dueDate') {
    return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
  } else if (this.sortBy === 'priority') {
    // 先定義優先順序的數值對應
    const getPriorityValue = (priority: string): number => {
      if (priority === 'high') return 0;
      if (priority === 'medium') return 1;
      if (priority === 'low') return 2;
      return 3; // 預設值，用於處理未知優先級
    };

    return getPriorityValue(a.priority) - getPriorityValue(b.priority);
  }
  return 0;
});

    return result;
  }

  isRiskOpportunitySelected(option: string): boolean {
    return this.currentItem.riskOpportunity?.includes(option) || false;
  }

  toggleRiskOpportunity(option: string): void {
    if (!this.currentItem.riskOpportunity) {
      this.currentItem.riskOpportunity = [];
    }

    const index = this.currentItem.riskOpportunity.indexOf(option);
    if (index === -1) {
      this.currentItem.riskOpportunity.push(option);
    } else {
      this.currentItem.riskOpportunity.splice(index, 1);
    }
  }

  isSolutionSelected(option: string): boolean {
    return this.currentItem.solution?.includes(option) || false;
  }

  toggleSolution(option: string): void {
    if (!this.currentItem.solution) {
      this.currentItem.solution = [];
    }

    const index = this.currentItem.solution.indexOf(option);
    if (index === -1) {
      this.currentItem.solution.push(option);
    } else {
      this.currentItem.solution.splice(index, 1);
    }
  }

  private generateUniqueId(): string {
    return Date.now().toString();
  }

  private refreshFilteredItems(): void {
    // 根據過濾條件重新計算 filteredItems
  }

  openComplianceImportModal(): void {
    console.log('this.unfitItems', this.unfitItems);

    this.showComplianceImportModal = true;
    this.selectedUnfitItemIds.clear();
    // 可根據實際情況設置 companyId
    // this.companyId = 'your-company-id';
    console.log('開啟合規判斷匯入視窗');
  }

  closeComplianceImportModal(): void {
    this.showComplianceImportModal = false;
  }

  // 勾選checkbox
  toggleUnfitItemSelection(id: string): void {
    if (this.selectedUnfitItemIds.has(id)) {
      this.selectedUnfitItemIds.delete(id);
    } else {
      this.selectedUnfitItemIds.add(id);
    }
  }

  // 匯入選取的不符合項目
  importSelectedUnfitItems(): void {
    const selectedItems = this.unfitItems.filter((item) =>
      this.selectedUnfitItemIds.has(item.id)
    );
    const newTrackingItems: law_unfit_list_extend[] = selectedItems.map((item) => {
      const baseItem: law_unfit_list = {
        id: item.id,
        companyid: environment.companyid,
        topic: item.topic || '',
        title: item.title || '',
        missionid: item.missionid || '',
        check_result_id: item.id, // 可以使用原始 id 作為 check_result_id

        law_id: item.law_id || '',
        law_name: item.law_name || '',
        article_id: item.article_id || '',
        article_no: item.article_no || '',
        article_content: item.article_content || '',
        current_status: item.current_status || '',

        assignee: '', // 可讓使用者後續編輯
        email: '',
        dueDate: '', // 可讓使用者後續編輯

        riskOpportunity: [],
        solution: [],
        improvementContent: '',
        attachments: [],
        status: 'pending',
        priority: 'medium',
        createdAt: item.createdAt
          ? item.createdAt.split('T')[0]
          : new Date().toISOString().split('T')[0],
        updatedAt: item.last_updated_date ||
          item.createdAt?.split('T')[0] ||
          new Date().toISOString().split('T')[0]
      };
      return createExtendedRegulationUnfitItem(baseItem);
    });
    this.trackingItems = this.trackingItems.concat(newTrackingItems);
    this.closeComplianceImportModal();
  }

  onItemsImported(event: any): void {
    if (Array.isArray(event)) {
      const companyid = environment.companyid ;
      const apiUrl = `${this.apiUrl}/api/regulation/unfit/add`;
      const updateCheckResultUrl = `${this.apiUrl}/api/law_check_list/update_unfit_id`;

      // 將每個匯入項目呼叫 API 新增，並於成功後更新 law_check_result
      const addRequests = event.map((item: any) => {
        // 使用工廠函式建立標準化的物件
        const itemData = createRegulationUnfitItem(item, companyid);

        console.log('匯入項目資料:', itemData);

        // 發送到 API
        return this.http
          .post<any>(apiUrl, itemData)
          .toPromise()
          .then((res) => {
            if (res && res.success && res.data) {
              // 新增成功後，更新 law_check_result 的 unfit_id
              if (itemData.id && itemData.law_id && itemData.article_id) {
                return this.http
                  .post<any>(updateCheckResultUrl, itemData)
                  .toPromise()
                  .then(() => res);
              }
            }
            return res;
          });
      });

      // 批次執行所有新增請求
      if (addRequests.length > 0) {
        Promise.all(addRequests)
          .then((results: any[]) => {
            const createdItems = results
              .filter((res) => res && res.success && res.data)
              .map((res) => this.mapUnfitItemToTrackingItem(res.data));
            this.trackingItems = this.trackingItems.concat(createdItems);

            console.log('匯入成功的項目:', createdItems);
            console.log('當前 unfitItems:', this.unfitItems);

            // 從 unfitItems 移除已匯入的項目
            const importedIds = new Set(
              createdItems.map((i) => i.check_result_id)
            );

            console.log('已匯入的項目 ID:', importedIds);

            this.unfitItems = this.unfitItems.filter(
              (item) => !importedIds.has(item.id)
            );

            this.availableComplianceItems = this.unfitItems.length;
            this.showComplianceImportModal = false;
          })
          .catch(() => {
            alert('匯入時有部分資料新增失敗，請檢查網路或稍後再試');
            this.showComplianceImportModal = false;
          });
      } else {
        this.showComplianceImportModal = false;
      }
    } else {
      this.showComplianceImportModal = false;
    }
  }

  isDueDateOverdue(dueDate: string): boolean {
    if (!dueDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);
    return due <= today;
  }

  // 新增刪除確認相關的屬性
  showDeleteConfirm = false;
  itemToDelete: law_unfit_list_extend | null = null;
  isDeleting = false;

  // 新增審核確認相關的屬性
  showReviewConfirm = false;
  itemToReview: law_unfit_list_extend | null = null;
  reviewComment = '';
  isReviewing = false;

  // 新增符合性修正相關的屬性
  syncComplianceCorrection = false;
  complianceStatusMessage = '';

  // 根據狀態 value 取得對應的顯示文字
  getStatusDisplayText(statusValue: string): string {
    const statusOption = this.statusOptions.find(option => option.value === statusValue);
    return statusOption ? statusOption.key : statusValue;
  }

  // 處理符合性修正 checkbox 狀態變更
  onSyncComplianceCorrectionChange(): void {
    if (this.syncComplianceCorrection) {
      // 當勾選時，設定預設值
      const currentDate = new Date().toISOString().split('T')[0]; // yyyy-mm-dd 格式
      this.complianceStatusMessage = `於${currentDate}改善完成，由系統自動調整為符合。`;
    } else {
      // 當取消勾選時，清空內容
      this.complianceStatusMessage = '';
    }
  }

  // 顯示刪除確認對話框
  confirmDelete(item: law_unfit_list): void {
    this.itemToDelete = { ...item };
    this.showDeleteConfirm = true;
    document.body.style.overflow = 'hidden'; // 鎖定背景滾動
  }

  // 取消刪除操作
  cancelDelete(event?: MouseEvent): void {
    if (event && event.target !== event.currentTarget) {
      return; // 如果點擊的不是背景，就不關閉
    }
    this.showDeleteConfirm = false;
    this.itemToDelete = null;
    document.body.style.overflow = 'auto'; // 恢復背景滾動
  }

  // 執行刪除操作
  deleteItem(): void {
    if (!this.itemToDelete || this.isDeleting) return;

    this.isDeleting = true;
    const companyid = environment.companyid;
    const id = this.itemToDelete.id;

    // 呼叫刪除 API
    const apiUrl = `${this.apiUrl}/api/regulation/unfit/delete/${id}?companyid=${companyid}`;

    this.http.delete<any>(apiUrl).subscribe({
      next: (res) => {
        if (res && res.success) {
          // 從列表中移除該項目
          this.trackingItems = this.trackingItems.filter(
            (item) => item.id !== id
          );

          // 關閉所有對話框
          this.cancelDelete(); // 關閉確認對話框
          this.closeItemModal(); // 關閉編輯對話框

          // 可以顯示成功訊息
          alert('不合規項目已成功刪除');
        } else {
          alert(res?.message || '刪除失敗');
        }
        this.isDeleting = false;
      },
      error: (err) => {
        if (err.status === 404) {
          alert('找不到要刪除的項目');
        } else {
          alert('刪除失敗，請稍後再試');
        }
        console.error('API 刪除錯誤:', err);
        this.isDeleting = false;
        this.cancelDelete();
      },
    });
  }

  // 顯示審核確認對話框
  openReviewModal(item: law_unfit_list): void {
    this.itemToReview = { ...item };
    this.reviewComment = '';
    this.syncComplianceCorrection = false;
    this.complianceStatusMessage = '';
    this.showReviewConfirm = true;
    document.body.style.overflow = 'hidden'; // 鎖定背景滾動
  }

  // 取消審核操作
  cancelReview(event?: MouseEvent): void {
    if (event && event.target !== event.currentTarget) {
      return; // 如果點擊的不是背景，就不關閉
    }
    this.showReviewConfirm = false;
    this.itemToReview = null;
    this.reviewComment = '';
    this.syncComplianceCorrection = false;
    this.complianceStatusMessage = '';
    document.body.style.overflow = 'auto'; // 恢復背景滾動
  }

  // 執行審核操作
  confirmReview(): void {
    if (!this.itemToReview || this.isReviewing) {
      return;
    }

    this.isReviewing = true;
    const companyid = environment.companyid;
    const id = this.itemToReview.id;
    const check_result_id = this.itemToReview.check_result_id;

    console.log('開始審核項目:', this.itemToReview);

    // 準備API請求資料
    const updateData = {
      companyid: companyid,
      id: id,
      status: 'approved', // 更新狀態為審核完成
      approval_history: {
        action: 'review_completed',
        text: this.reviewComment || '審核完成',
        date: new Date().toISOString()
      }
    };

    console.log('發送審核請求:', updateData);

    // 調用審核API
    const apiUrl = `${this.apiUrl}/api/regulation/unfit/update-status`;

    this.http.post<any>(apiUrl, updateData).subscribe({
      next: (response) => {
        if (response && response.success) {
          console.log('審核成功:', response);

          // 更新本地項目狀態
          const itemIndex = this.trackingItems.findIndex(item => item.id === id);
          if (itemIndex !== -1) {
            this.trackingItems[itemIndex] = {
              ...this.trackingItems[itemIndex],
              status: 'approved'
            };
          }

          // 如果正在編輯此項目，也更新編輯中的項目
          if (this.currentItem.id === id) {
            this.currentItem.status = 'approved';
          }

          // 如果使用者選擇要同步修正符合性結果且項目有 check_result_id，呼叫相應的API
          if (this.syncComplianceCorrection && this.itemToReview?.check_result_id) {
            this.updateComplianceResult(companyid, check_result_id); //這邊的id要送入的是符合性判別結果的id，而不是不符合事項的id
          } else {
            // 如果不需要修正符合性或沒有 check_result_id，直接關閉對話框並顯示成功訊息
            this.cancelReview();
            this.closeItemModal(); // 關閉編輯視窗
            this.loadUnfitItems(); // 重新載入資料
            alert('審核完成！項目狀態已更新。');
          }

        } else {
          console.error('審核失敗:', response.message);
          alert('審核失敗: ' + (response.message || '未知錯誤'));
        }
        this.isReviewing = false;
      },
      error: (error) => {
        console.error('審核API調用失敗:', error);
        alert('審核失敗: ' + (error.error?.message || error.message || '網路錯誤'));
        this.isReviewing = false;
      }
    });
  }

  // 更新法規判別結果為符合
  private updateComplianceResult(companyid: string, id: string): void {
    const complianceApiUrl = `${this.apiUrl}/api/law_check_list/update_compliance_result`;

    const complianceData = {
      companyid: companyid,
      id: id, //law_check_result 裡面項目的id
      statusUpdate: this.complianceStatusMessage.trim() || undefined
    };

    console.log('發送符合性修正請求:', complianceData);

    this.http.post<any>(complianceApiUrl, complianceData).subscribe({
      next: (complianceResponse) => {
        if (complianceResponse && complianceResponse.success) {
          console.log('符合性修正成功:', complianceResponse);

          // 關閉審核對話框
          this.cancelReview();

          // 關閉編輯視窗
          this.closeItemModal();

          // 重新載入資料
          this.loadUnfitItems();

          // 顯示成功訊息
          alert('審核完成並已將鑑別結果修正為符合！');

        } else {
          console.error('符合性修正失敗:', complianceResponse.message);

          // 關閉審核對話框
          this.cancelReview();

          // 關閉編輯視窗
          this.closeItemModal();

          // 重新載入資料
          this.loadUnfitItems();

          // 顯示部分成功的訊息
          alert('審核完成，但符合性修正失敗: ' + (complianceResponse.message || '未知錯誤'));
        }
      },
      error: (error) => {
        console.error('符合性修正API調用失敗:', error);

        // 關閉審核對話框
        this.cancelReview();

        // 關閉編輯視窗
        this.closeItemModal();

        // 重新載入資料
        this.loadUnfitItems();

        // 顯示部分成功的訊息
        alert('審核完成，但符合性修正失敗: ' + (error.error?.message || error.message || '網路錯誤'));
      }
    });
  }

  // 加入以下屬性到您的元件中
  allSelected: boolean = false;

  // 增加以下方法到您的元件中
  toggleSelectAll(): void {
    this.allSelected = !this.allSelected;
    this.filteredItems.forEach(item => {
      item.selected = this.allSelected;
    });
  }

  toggleSelectItem(item: law_unfit_list_extend): void {
    item.selected = !item.selected;
    // 檢查是否所有項目都被選中
    this.allSelected = this.filteredItems.every(item => item.selected);
  }

  getSelectedCount(): number {
    return this.filteredItems.filter(item => item.selected).length;
  }

  exportSelectedItems(): void {
    const selectedItems = this.filteredItems.filter(item => item.selected);

    if (selectedItems.length === 0) {
      alert('請至少選擇一個項目進行匯出');
      return;
    }

    console.log('選取的項目:', selectedItems);

    // 獲取當前日期作為表單日期
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD格式

    // 轉換選取的項目到匯出格式
    const exportData = {
      "fileName": "Regulation_Checklist.xlsx",
      "companyname": environment.companyname ,
      "sheets": [
        {
          "sheetname": "追蹤改善項目一覽表",
          "title": "追蹤改善項目一覽表",
          "formNumber": "ES02-06-03-01",
          "formdate": formattedDate,
          "approvers": [
            "管理代表:_______",
            "部門主管:_______",
            "製表:_______"
          ],
          "header": {
            "tree": [
              { "text": "項次", "field": "itemNo", "bgColor": "#FFF2CC" },
              { "text": "法規名稱", "field": "lawName", "bgColor": "#FFF2CC" },
              { "text": "條文", "field": "article", "bgColor": "#FFF2CC" },
              { "text": "條文說明", "field": "articleDesc", "bgColor": "#FFF2CC" },
              { "text": "現況說明", "field": "currentDesc", "bgColor": "#FFF2CC" },
              {
                "text": "風險與機會判定(勾選)",
                "bgColor": "#FFF2CC",
                "children": [
                  { "text": "風險", "field": "risk", "bgColor": "#FFF2CC" },
                  { "text": "機會", "field": "opportunity", "bgColor": "#FFF2CC" }
                ]
              },
              {
                "text": "解決方案(勾選)",
                "bgColor": "#FFF2CC",
                "children": [
                  { "text": "消除", "field": "fire", "bgColor": "#FFF2CC" },
                  { "text": "取代", "field": "replace", "bgColor": "#FFF2CC" },
                  { "text": "工程控制", "field": "engineering", "bgColor": "#FFF2CC" },
                  { "text": "標準監管/管理控制", "field": "standard", "bgColor": "#FFF2CC" },
                  { "text": "防護具", "field": "ppe", "bgColor": "#FFF2CC" }
                ]
              },
              { "text": "改善內容", "field": "improvement", "bgColor": "#FFF2CC" },
              { "text": "責任部門/負責人", "field": "owner", "bgColor": "#FFF2CC" },
              { "text": "預計結案日期", "field": "dueDate", "bgColor": "#FFF2CC" },
              { "text": "備註", "field": "note", "bgColor": "#FFF2CC" }
            ]
          },
          "data": selectedItems.map((item, index) => {
            // 風險與機會判定轉換
            const risk = item.riskOpportunity?.includes('風險') ? "✓" : "";
            const opportunity = item.riskOpportunity?.includes('機會') ? "✓" : "";

            // 解決方案轉換
            const fire = item.solution?.includes('消除') ? "✓" : "";
            const replace = item.solution?.includes('取代') ? "✓" : "";
            const engineering = item.solution?.includes('工程控制') ? "✓" : "";
            const standard = item.solution?.includes('標誌警告/管理控制') ? "✓" : "";
            const ppe = item.solution?.includes('防護具') ? "✓" : "";

            // 格式化日期，避免無效日期
            let formattedDueDate = '';
            if (item.dueDate) {
              try {
                const dueDate = new Date(item.dueDate);
                formattedDueDate = isNaN(dueDate.getTime()) ? '' :
                    dueDate.toISOString().split('T')[0];
              } catch (e) {
                formattedDueDate = '';
              }
            }

            // 返回格式化的數據
            return {
              "itemNo": index + 1, // 從1開始的項次編號
              "lawName": item.law_name || '',
              "article": item.article_no || '',
              "articleDesc": item.article_content || '',
              "currentDesc": item.current_status || '',
              "risk": risk,
              "opportunity": opportunity,
              "fire": fire,
              "replace": replace,
              "engineering": engineering,
              "standard": standard,
              "ppe": ppe,
              "improvement": item.improvementContent || '',
              "owner": item.assignee || '',
              "dueDate": formattedDueDate,
              "note": item.current_status || '' // 如果有備註欄位的話
            };
          })
        }
      ]
    };

    console.log('匯出資料格式:', exportData);

    // 更新匯出狀態為進行中
    this.isExporting = true;

    try {
      // 呼叫API生成Excel檔案
      const url = `${this.apiUrl}/api/excel/generate`;

      // 使用HTTP請求發送數據到API，並接收二進制檔案
      this.http.post(url, exportData, {
        responseType: 'blob',  // 指定回應類型為二進制檔案
        observe: 'response'    // 取得完整的HTTP回應
      }).subscribe({
        next: (response) => {
          // 檢查回應是否成功
          if (response.status === 200 && response.body) {
            // 從回應頭取得檔案名稱，如果沒有則使用預設名稱
            let fileName = exportData.fileName;
            const contentDisposition = response.headers.get('content-disposition');
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
              if (fileNameMatch && fileNameMatch.length === 2) {
                fileName = fileNameMatch[1];
              }
            }

            // 創建檔案下載連結
            const blob = new Blob([response.body], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;

            // 模擬點擊下載
            document.body.appendChild(link);
            link.click();

            // 清理
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

            console.log('Excel匯出成功!');
            this.isExporting = false; // 設置匯出狀態為完成
          } else {
            // 如果回應不是成功的二進制檔案
            console.error('Excel匯出失敗: 無效的回應');
            alert('匯出Excel失敗，請稍後再試');
            this.isExporting = false; // 發生錯誤時也要設置匯出狀態為完成
          }
        },
        error: (error) => {
          console.error('Excel匯出錯誤:', error);

          // 檢查錯誤回應的內容，如果包含JSON錯誤訊息則顯示
          if (error.error instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorJson = JSON.parse(reader.result as string);
                alert(`匯出Excel失敗: ${errorJson.message || '未知錯誤'}`);
              } catch {
                alert('匯出Excel失敗，請稍後再試');
              }
            };
            reader.readAsText(error.error);
          } else {
            // 一般錯誤訊息
            alert('匯出Excel失敗，請稍後再試');
          }
          this.isExporting = false; // 確保在任何錯誤情況下都重置匯出狀態
        },
        complete: () => {
          // 匯出完成，隱藏載入指示器
          console.log('Excel匯出請求完成');
          this.isExporting = false; // 確保匯出狀態被重置
        }
      });
    } catch (error) {
      console.error('發送匯出請求時發生錯誤:', error);
      alert('匯出Excel過程中發生錯誤，請稍後再試');
      this.isExporting = false; // 確保在任何錯誤情況下都重置匯出狀態
    }
  }
}

